// extracted by mini-css-extract-plugin
export default {"container":"style_container__cqlCG","qrContainer":"style_qrContainer__mtu1J","tecketDetailsContainer":"style_tecketDetailsContainer__6Xe4r"};